import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { upperFirst } from 'lodash';

class ActiveFiltersCounter extends Component {
  render() {
    if (this.props.hide) {
      return <div></div>;
    }

    const styles = {
      marginLeft: '7px',
      display: 'inline',
      fontSize: '14px',
      fontWeight: '600',
    };

    return (
      <div style={styles}>
        ({this.props.selectedItems}/{this.props.items})
      </div>
    );
  }
}

ActiveFiltersCounter.propTypes = {
  name: PropTypes.string.isRequired,
  hide: PropTypes.string,
  isCf: PropTypes.bool
};

export const mapStateToProps = (state, ownProps) => {
  const chart = state.filters.chart;
  const name = ownProps.isCf ? ownProps.name : upperFirst(ownProps.name);
  const filter = !!state.filters[`all${name}`] ? state.filters[`all${name}`] : [];
  const items = _.filter(filter, i => !i.hidden).length;
  const selected = _.filter(state.filters[chart][`selected${name}`], id => {
    const item = _.find(filter, { value: id });
    return item && !item.hidden;
  });
  const selectedItems = selected.length;
  return {
    items,
    selectedItems,
  };
};

const connected = connect(mapStateToProps)(ActiveFiltersCounter);
export { connected as ActiveFiltersCounter };
